module.exports = __webpack_public_path__ + "static/media/close-circle-grey-icon.da8cb23b.png";